export default "__VITE_ASSET__79069cbd__"